export default {
	activity_appointment: 'Appointment',
	activity_dataset: 'Dataset',
	activity_document: 'Document',
	activity_mail: 'Email',
	activity_message: 'Message',
	activity_note: 'Note',
	activity_phonecall: 'Phone call',
	activity_scheduled_activity: 'Scheduled activity',
	activity_task: 'Task',
};
